import { ToolbarCollectionState } from './ToolbarCollectionState';

export interface ICollectionComponentState {
  toolbar: ToolbarCollectionState<any, any>;
}
